import { render } from "./designerApplyInfo.vue?vue&type=template&id=b97d101c&scoped=true"
import script from "./designerApplyInfo.vue?vue&type=script&lang=js"
export * from "./designerApplyInfo.vue?vue&type=script&lang=js"

import "./designerApplyInfo.vue?vue&type=style&index=0&id=b97d101c&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b97d101c"]])

export default __exports__